import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'df-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
